import { getMessageValue } from "@ignitesales/neuro-application/src/i18n/messageUtil";
import React from 'react';
import { FormattedHTMLMessage, FormattedMessage, useIntl } from "react-intl";

const Footer = () => {
  const cssBEM = "footer";
  const intl = useIntl();
  const phoneNumber = getMessageValue(intl.locale, `footer.phoneNumber`);

  return <footer className={ cssBEM }>
    <div className="container">
      <div className={`${cssBEM}__phoneNumber`}>&nbsp;</div>
      <div className={`${cssBEM}__copyright`}>
        <FormattedHTMLMessage id="footer.copyright" tagName="span" values={{
          year: (new Date()).getFullYear()
        }} />
      </div>
      <div className={`${cssBEM}__fdic-member`}>
        {/* <ReactSVG src="/classpath/assets/images/fdic-equal-housing-logo.svg" wrapper="span"/> */}
      </div>
    </div>
  </footer>
};

export default Footer;
